import { render } from "./create.vue?vue&type=template&id=4f9106e3&scoped=true"
import script from "./create.vue?vue&type=script&lang=ts"
export * from "./create.vue?vue&type=script&lang=ts"

import "./create.vue?vue&type=style&index=0&id=4f9106e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f9106e3"

export default script